export const invalidWordReg = /[^a-zA-Z]/g;

export const BLANK = '&nbsp;';

export const LINE_LENGTH = 24;